export const TOTAL_COUNT_RESPONSE_HEADER = 'X-Total-Count';
export const PAGE_HEADER = 'page';
export const PAGE_NUMBER = 0;
export const ITEMS_PER_PAGE = 10;
export const ALL_ITEMS = 100000000;
